module.exports = __webpack_public_path__ + "img/one-enabled-big.3c6865c9.svg";